export default __webpack_public_path__ + "static/media/drush.0fdacecc.svg";